import type { AlertModalProps } from '@smiledragon-corp/sds-system';
import { AlertModal as SDAlertModal } from '@smiledragon-corp/sds-system';

export const AlertModal = (props: AlertModalProps) => {
  return <SDAlertModal {...props} />;
};
